import { createAPI } from "../apisServer";

import BaseUrl from "../baseUrls";

const banco = BaseUrl.dataBase;
const apiServer = createAPI("multiTenant");

const reqFornecedor = {
	listPaginate: async function (param, paramValue, active, page, perpage = 15) {
		return apiServer
			.get("portal/v1/fornecedor", {
				params: {
					param,
					paramValue,
					active,
					page,
					perpage,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response; // Revert to returning the entire response
			})
			.catch((error) => {
				throw error;
			});
	},
	listID: async function (id) {
		return apiServer
			.get(`portal/v1/fornecedor/${id}`, {
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	insert: async function (data) {
		return apiServer
			.post("portal/v1/fornecedor", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqFornecedor;
